// 百度统计
if(process.browser) {
    try {
        window._hmt = window._hmt || [];

        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?f0bd07e6681b235440e5138c3a346b47";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
    } catch (e) {
        // e
    }
}